import {
  AddCustomerPayload,
  CreateCustomerPurchasePayload,
  GetCustomersParams,
} from "@/models/payload/customer";
import clubRequest from "../axios";
import { CreateUsers } from "./type";
import { AddCustomerOwnerCommand, CustomerPurchaseListParams } from "@/models/club";

const addCustomer = async (payload: AddCustomerPayload) =>
  (await clubRequest.customerCreate(payload)).data;

const editCustomer = async (payload: AddCustomerPayload) =>
  (await clubRequest.customerUpdate(payload)).data;

const deleteCustomer = async (id: number) =>
  (await clubRequest.customerDelete({ id })).data;

const getCustomers = async (params: GetCustomersParams) =>
  (await clubRequest.customerList(params)).data;

const getCustomerPurchase = async (params: CustomerPurchaseListParams = {}) =>
  (await clubRequest.customerPurchaseList(params)).data;

const getInvoices = async (params: CustomerPurchaseListParams = {}) => {
  const response = await clubRequest.customerPurchaseList(params);
  const payload = response.data as unknown as {
    result?: typeof response.data;
    count?: number;
  };
  const result = Array.isArray(response.data)
    ? response.data
    : payload.result || [];
  const headerCount = Number(response.headers["x-total-count"]);

  return {
    result,
    count: Number.isFinite(payload.count)
      ? payload.count
      : Number.isFinite(headerCount)
        ? headerCount
        : undefined,
  };
};

const getInvoiceDetail = async (purchaseId: number) =>
  (await clubRequest.customerPurchaseDetail({ purchaseId })).data;

const getCustomerByPhoneNumber = async (phoneNumber: string) =>
  (await clubRequest.customerInfoList({ phoneNumber })).data;

const getCustomerInMerchantByPhoneNumber = async (phoneNumber: string) =>
  (
    await clubRequest.customerMobileNumberList({
      mobileNumber: phoneNumber,
    })
  ).data;

const getCustomerById = async (id: number) =>
  (await clubRequest.customerInfoDetail({ id })).data;

const addCustomerPurchase = async (params: CreateCustomerPurchasePayload) =>
  (await clubRequest.customerPurchaseCreate(params)).data;

const addCustomersBulk = async (params: CreateUsers) =>
  (await clubRequest.customerBulkCreate(params)).data;

const assignCustomer = async (params: AddCustomerOwnerCommand) =>
  (await clubRequest.customerAddOwnerCreate(params)).data;

const customerService = {
  addCustomer,
  getCustomers,
  getCustomerByPhoneNumber,
  getCustomerById,
  addCustomerPurchase,
  getCustomerPurchase,
  getInvoices,
  getInvoiceDetail,
  editCustomer,
  addCustomersBulk,
  deleteCustomer,
  getCustomerInMerchantByPhoneNumber,
  assignCustomer,
};

export default customerService;
